import type {
  ParcelDto,
  ParcelEventDto,
} from "@babackapp/private-api-client/generated/schema";
import { format, Locale } from "date-fns";
import { de, enUS, es, fr } from "date-fns/locale";

export const deliveredStatus: ParcelEventDto["status"][] = [
  "DELIVERED",
  "DELIVERED_TO_NEIGHBOUR",
  "COLLECTED_AT_PICKUP",
];

export const arrivedStatus: ParcelEventDto["status"][] = [
  ...deliveredStatus,
  "AVAILABLE_FOR_PICKUP",
  "WAITING_AT_PICKUP_POINT",
  "WAITING_AT_PICKUP_POINT_SEVERE",
  "DISPATCHED_TO_OTHER_PICKUP_POINT",
];

export const localesMap: { [key: string]: Locale } = {
  fr: fr,
  en: enUS,
  es: es,
  de: de,
};

export function getDateFnsLocale(customerLocale: string): Locale {
  return localesMap[customerLocale] || enUS;
}

export function findDeliveredEvent(
  parcel: ParcelDto,
): ParcelEventDto | undefined {
  return parcel.events.find((event) => deliveredStatus.includes(event.status));
}

export function findArrivedEvent(
  parcel: ParcelDto,
): ParcelEventDto | undefined {
  return parcel.events.find((event) => arrivedStatus.includes(event.status));
}

export function formatDeliveryDate(
  date: number | Date,
  customerLocale: string,
): string {
  const dateFnsLocale = getDateFnsLocale(customerLocale);
  return format(date, "EEEE d MMMM yyyy", { locale: dateFnsLocale });
}

export function formatDeliveryDateWindow(
  minimumDate: number | Date,
  maximumDate: number | Date,
  customerLocale: string,
  translations: { from: string; to: string },
): string {
  const dateFnsLocale = getDateFnsLocale(customerLocale);
  const min = format(minimumDate, "d MMM", { locale: dateFnsLocale });
  const max = format(maximumDate, "d MMM yyyy", { locale: dateFnsLocale });
  return `${translations.from} ${min} ${translations.to} ${max}`;
}
